import React from 'react';
import { BringzzBottomDrawer, BringzzButton, BringzzText } from '@bringzz/components';

const ProductSelectionModal = ({
    isOpen,
    prescriptionData,
    selectedProducts,
    processingProducts,
    onProductSelection,
    onConfirm,
    onCancel
}) => {
    return (
        <BringzzBottomDrawer
            isOpen={isOpen}
            close={onCancel}
            title="Select Products from Prescription"
        >
            <div className="px-4 py-6 max-h-[70vh] overflow-y-auto">
                {/* Prescription Info */}
                {prescriptionData?.scan_results && (
                    <div className="mb-6 p-4 bg-gray-50 rounded">
                        <BringzzText tag="h4" className="font-semibold mb-2">
                            Prescription Details
                        </BringzzText>
                        <div className="text-sm space-y-1">
                            <p><span className="font-medium">Patient:</span> {prescriptionData.scan_results.name}</p>
                            <p><span className="font-medium">SVNR:</span> {prescriptionData.scan_results.svnr}</p>
                            <p><span className="font-medium">Prescription ID:</span> {prescriptionData.scan_results.rez_id}</p>
                            <p><span className="font-medium">Issued:</span> {prescriptionData.scan_results.issued_date}</p>
                            <p><span className="font-medium">Expires:</span> {prescriptionData.scan_results.expired_date}</p>
                        </div>
                    </div>
                )}

                {/* Product Selection List */}
                <div className="space-y-4">
                    {selectedProducts.map((product, index) => (
                        <div key={index} className="border rounded-lg p-4">
                            <div className="flex justify-between items-start mb-3">
                                <div className="flex-1">
                                    <BringzzText tag="h4" className="font-semibold">
                                        {product.label}
                                    </BringzzText>
                                    <div className="text-sm text-gray-600 mt-1">
                                        <p>Package: {product.pck_size}</p>
                                        <p>Quantity: {product.op}</p>
                                        {product.sig && <p>Dosage: {product.sig}</p>}
                                        {product.note && <p>Note: {product.note}</p>}
                                    </div>
                                </div>
                            </div>

                            {/* Product matches dropdown */}
                            {product.ids && product.ids.length > 1 && (
                                <div className="mt-3">
                                    <label className="text-sm font-medium text-gray-700">
                                        Select matching product:
                                    </label>
                                    <select
                                        className="mt-1 w-full p-2 border rounded"
                                        value={product.selectedId}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            const selectedMatch = product.ids.find(id => String(id[0]) === String(selectedValue));
                                            if (selectedMatch) {
                                                onProductSelection(index, selectedMatch);
                                            }
                                        }}
                                    >
                                        {product.ids.map((match, matchIndex) => (
                                            <option key={matchIndex} value={match[0]}>
                                                {match[1]}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {/* Show selected product if only one match */}
                            {product.ids && product.ids.length === 1 && (
                                <div className="mt-3 p-2 bg-green-50 rounded">
                                    <p className="text-sm text-green-700">
                                        <span className="font-medium">Selected:</span> {product.selectedName}
                                    </p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="mt-6 space-y-3">
                    <BringzzButton
                        className="bg-magic-lilac w-full flex justify-center"
                        onClick={onConfirm}
                        disabled={processingProducts || selectedProducts.length === 0}
                    >
                        {processingProducts ?
                            'Adding...' :
                            `Add ${selectedProducts.length} Product${selectedProducts.length > 1 ? 's' : ''} to Basket`
                        }
                    </BringzzButton>

                    <BringzzButton
                        className="border border-gray-300 w-full flex justify-center"
                        onClick={onCancel}
                        disabled={processingProducts}
                    >
                        Cancel
                    </BringzzButton>
                </div>
            </div>
        </BringzzBottomDrawer>
    );
};

export default ProductSelectionModal;
